"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = exports.Col = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = require("../../utils/classify");
var _GridModule = _interopRequireDefault(require("./Grid.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const GRID_SYSTEM_MAP = {
  small: 24,
  medium: 12,
  large: 6,
  autoFill: 'auto-fill',
  autoFit: 'auto-fit'
};
const Row = _ref => {
  let {
    className,
    children,
    span = 1,
    gridType = 'medium',
    repeatTracks = '1fr'
  } = _ref;
  const gridRepeatCount = GRID_SYSTEM_MAP[gridType];
  let columnSpanCount = 0;
  let lastChildColCount = 0;
  const childrenWithProps = React.Children.map(children, child => {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      const {
        span = 1,
        offset = 0
      } = child.props;
      if (span < 1) {
        console.error(`span can not be less than one`);
        return;
      }
      if (offset < 0) {
        console.error(`offset can not be negative`);
        return;
      }
      lastChildColCount = columnSpanCount;
      columnSpanCount = lastChildColCount + offset + span;
      let gridColumnStart = 0,
        gridColumnEnd = 0;
      if (gridType === 'autoFill' || gridType === 'autoFit') {
        gridColumnStart = 'auto';
        return /*#__PURE__*/React.cloneElement(child, {
          gridColumnStart,
          gridColumnEnd: `span ${span}`
        });
      } else if (typeof gridRepeatCount === 'number' && columnSpanCount <= gridRepeatCount) {
        gridColumnStart = lastChildColCount + offset + 1;
        return /*#__PURE__*/React.cloneElement(child, {
          gridColumnStart,
          gridColumnEnd: `span ${span}`
        });
      } else {
        console.error(`number of column exceed ${gridRepeatCount}`);
      }
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "Grid",
    className: (0, _classify.classify)(_GridModule.default.gridRow, className),
    style: {
      '--grid-repeat-count': gridRepeatCount,
      '--repeat-tracks': repeatTracks
    }
  }, childrenWithProps);
};
exports.Row = Row;
const Col = _ref2 => {
  let {
    className,
    children,
    gridColumnStart,
    gridColumnEnd
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_GridModule.default.gridColumn, className),
    style: {
      '--grid-column-start': gridColumnStart,
      '--grid-column-end': gridColumnEnd
    }
  }, children);
};
exports.Col = Col;